import React from 'react';
import _ from 'lodash';

import slugify from 'slugify';
import { HTMLContent } from '~components/Content';
import { stateEnums } from '~utils/enums';
import { TableData, TableRow } from '~components/common/Table';
import PropTypes from 'prop-types';
import { registrationNotRequired } from '~components/Register/specialCases';
import { rowRendererProps } from '../propTypes';
import { RowDataRenderer } from './default';

function SameDayRegistrationNotes({ sdrEarlyVotingData, sdrElectionDayData }) {
  const sdrNotesEarlyVoting = sdrEarlyVotingData
    ? sdrEarlyVotingData.footnotes
    : null;
  const sdrNotesElectionDay = sdrElectionDayData
    ? sdrElectionDayData.footnotes
    : null;
  const notes = [];
  if (sdrNotesEarlyVoting) {
    notes.push(sdrNotesEarlyVoting);
  }

  if (sdrNotesElectionDay && sdrNotesElectionDay !== sdrNotesEarlyVoting) {
    notes.push(sdrNotesElectionDay);
  }

  if (!sdrNotesEarlyVoting && !sdrNotesElectionDay) {
    return '';
  }

  if (notes.length === 1) {
    return <div>{notes[0]}</div>;
  }

  return (
    <ul>
      {notes.filter(Boolean).map((note) => (
        <li>{note}</li>
      ))}
    </ul>
  );
}

SameDayRegistrationNotes.propTypes = {
  sdrEarlyVotingData: PropTypes.object,
  sdrElectionDayData: PropTypes.object,
};

export default function SameDayRegistrationRowRenderer({ state }) {
  const stateName = state.fieldValue;
  const stateData = _.keyBy(state.nodes, 'field_type');
  const stateSlug = slugify(stateName.toLowerCase());
  const stateCode = stateEnums.find(
    (e) => e.option.toLowerCase() === stateName.toLowerCase()
  ).value;

  // ND doesn't have voter registration, so it's neither true nor false. It's N/A.
  const noSdrValue = registrationNotRequired.includes(stateCode) ? 'N/A' : 'No';
  const sdrEarlyVoting = stateData.has_sdr_early_voting
    ? stateData.has_sdr_early_voting.bool_value
    : false;
  const sdrElectionDay = stateData.has_sdr_election_day
    ? stateData.has_sdr_election_day.bool_value
    : false;
  const sdrWhereToGo = stateData.sdr_locations
    ? stateData.sdr_locations.html
    : '';
  const sdrWhatToBring = stateData.id_laws_sdr
    ? stateData.id_laws_sdr.html
    : '';

  const hasSdr = sdrEarlyVoting || sdrElectionDay;

  return (
    <TableRow id={stateSlug}>
      <TableData>
        <a
          href={`/how-to-vote/${stateSlug}/`}
          title={`How to vote in ${stateName}`}
        >
          {stateName}
        </a>
      </TableData>
      <RowDataRenderer
        columns={[
          {
            title: 'Same-day registration available?',
            valueNode: (
              <ul>
                <li>
                  <span className='font-bold'>During early voting:</span>{' '}
                  {sdrEarlyVoting ? 'Yes' : noSdrValue}
                </li>
                <li>
                  <span className='font-bold'>On Election Day:</span>{' '}
                  {sdrElectionDay ? 'Yes' : noSdrValue}
                </li>
              </ul>
            ),
          },
          {
            title: 'Where to go',
            valueNode: (
              <div>
                {hasSdr ? <HTMLContent content={sdrWhereToGo} /> : 'N/A'}
              </div>
            ),
          },
          {
            title: 'What to bring',
            valueNode: (
              <div>
                {hasSdr ? <HTMLContent content={sdrWhatToBring} /> : 'N/A'}
              </div>
            ),
          },
          {
            title: 'Notes',
            valueNode: (
              <div>
                {hasSdr ? (
                  <SameDayRegistrationNotes
                    sdrEarlyVotingData={stateData.has_sdr_early_voting}
                    sdrElectionDayData={stateData.has_sdr_election_day}
                  />
                ) : (
                  'N/A'
                )}
              </div>
            ),
          },
        ]}
      />
    </TableRow>
  );
}

SameDayRegistrationRowRenderer.propTypes = rowRendererProps;
